import Hls from "hls.js"
import { useEffect, useRef } from "react";

export default function VideoPlayer(props) {
    
    useEffect(()=> {
        const hls = new Hls({
        "debug": true
        });

        const scriptText = `

            const ${props.channelName} = document.getElementById('videoABC');

            if (Hls.isSupported()) {
                const hls = new Hls();
                hls.loadSource('${props.videoURL}');
                hls.attachMedia(${props.channelName});
                hls.on(Hls.Events.MANIFEST_PARSED, function () {
                ${props.channelName}.play();
                });
            } else if (${props.channelName}.canPlayType('application/vnd.apple.mpegurl')) {
                ${props.channelName}.src = '${props.videoURL}';
                ${props.channelName}.addEventListener('loadedmetadata', function () {
                ${props.channelName}.play();
                });
            }
        `;
        
        const script = document.createElement('script');
        script.type = 'text/javascript'
        script.innerText = scriptText;
        document.body.appendChild(script)

        return() => {
            document.body.removeChild(script);
        };
    }, []);

    const isMultiViewer = props.isMultiViewer;

    return(
        <div>
            <video id="videoABC" className={isMultiViewer ? "video-player-multiviewer" : "video-player-channel-layout"} controls autoPlay={false} muted={true} />
        </div>
    );
}


